$(document).ready(function() {

    let owl_2 = $("#reviews-section-2 .owl-carousel").owlCarousel({
        items: 3,
        nav: false,
        dots: false,
        smartSpeed: 800,
        margin: 100,
        stagePadding: 40,
        responsive: {
            0: {
                items: 1,
                margin: 30,
                stagePadding: 40,
            },
            768: {
                items: 2,
                margin: 50,
                stagePadding: 40,
            },
            1280: {
                items: 3,
                margin: 100,
                stagePadding: 40,
            }
        }
    }).on('changed.owl.carousel', function(event) {
        if (event.item.index === 0)
            $('#reviews-section-2 .side-nav .owl-prev').prop('disabled', true);
        else 
            $('#reviews-section-2 .side-nav .owl-prev').prop('disabled', false);

        if (event.item.index === event.item.count - event.page.size)
            $('#reviews-section-2 .side-nav .owl-next').prop('disabled', true);
        else
            $('#reviews-section-2 .side-nav .owl-next').prop('disabled', false);
    });

    $("#reviews-section-2 .side-nav .owl-prev").on('click', function() {
        owl_2.trigger('prev.owl.carousel');
    });
    $("#reviews-section-2 .side-nav .owl-next").on('click', function() {
        owl_2.trigger('next.owl.carousel');
    });

    let owl_3 = $("#reviews-section-3 .owl-carousel").owlCarousel({
        items: 2,
        nav: false,
        dots: false,
        smartSpeed: 800,
        margin: 30,
        stagePadding: 50,
        responsive: {
            0: {
                items: 1,
                margin: 20,
                stagePadding: 30,
            },
            768: {
                items: 2,
                margin: 20,
                stagePadding: 40,
            },
            1280: {
                items: 2,
                margin: 30,
                stagePadding: 50,
            }
        }
    }).on('changed.owl.carousel', function(event) {
        if (event.item.index === 0)
            $('#reviews-section-3 .side-nav .owl-prev').prop('disabled', true);
        else 
            $('#reviews-section-3 .side-nav .owl-prev').prop('disabled', false);

        if (event.item.index === event.item.count - event.page.size)
            $('#reviews-section-3 .side-nav .owl-next').prop('disabled', true);
        else
            $('#reviews-section-3 .side-nav .owl-next').prop('disabled', false);
    });

    $("#reviews-section-3 .side-nav .owl-prev").on('click', function() {
        owl_3.trigger('prev.owl.carousel');
    });
    $("#reviews-section-3 .side-nav .owl-next").on('click', function() {
        owl_3.trigger('next.owl.carousel');
    });

});